import React from "react";
import CustomIcon from "../../../components/CustomIcon";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import {Tag} from "../../../components/table/Status";

function CampaignItem({campaign}) {
  return (
    <div className="w-full p-3 border bg-white space-x-2 rounded-md flex items-center mb-2">
      <div className="rounded-full border h-16 w-16 bg-white shrink-0 overflow-hidden flex justify-center items-center">
        <CustomIcon icon="vaccines" size="3xl"/>
      </div>
      <div className="w-full">
        <div className="flex justify-between mb-1 text-sm sm:text-md flex-col-reverse items-start sm:flex-row sm:items-center">
          <div className="font-medium">{campaign.title}</div>
          <div className="sm:text-md text-xs">Appointment Date: {campaign.appointment_date}</div>
        </div>
        <div className="flex justify-between flex-col items-start sm:flex-row sm:items-center">
          <Tag label={campaign.type}/>
          <div className="flex flex-wrap font-medium space-x-1">
            <div>
              (Qty: {campaign.quantity})
            </div>
            <div>NPR. {campaign.price.toFixed(2)}</div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default CampaignItem